import COUNTRY from 'country-json/src/country-by-abbreviation.json';

// Le front consomme les options effectives, manuelles ou injectées par l'API.
// Le serveur vérifie le compte Stripe ; le navigateur contrôle la disponibilité.
export function walletOptionEnabled(org, assoc, platform) {
    const configs = (Array.isArray(org?.config) ? org.config : []).filter(item =>
        item.key === platform + '_PAIEMENT_METHOD' && item.assoc === assoc);
    return configs.length > 0 && !configs.some(item => item.enabled === false || item.value === false);
}
export const hasWalletOptions = (org, assoc) => ['STRIPE.APPLEPAY', 'STRIPE.GOOGLEPAY'].some(platform => walletOptionEnabled(org, assoc, platform));

export function oneOffCard(values = {}, config = {}) {
    return !(values.abo ?? config.abo) && !config.update && !config.fixedNbMonth && !config.service?.recurrent &&
        !config.subscriptionMethodChange && !config.subscriptionManualSettlement &&
        !(Number(values.divide) > 1 || Number(values.nbMonth) > 1) &&
        ['CARD', 'STRIPE.APPLEPAY', 'STRIPE.GOOGLEPAY', undefined, null, ''].includes(values.platform);
}

export const walletMethodForPlatform = platform => ({'STRIPE.APPLEPAY': 'apple_pay', 'STRIPE.GOOGLEPAY': 'google_pay'})[platform] || null;
export const walletChoices = (available, org, assoc) => [
    ...(available?.applePay ? [{value: 'STRIPE.APPLEPAY', method: 'apple_pay', image: 'apple-pay.svg', imageVariant: 'applePay'}] : []),
    ...(available?.googlePay ? [{value: 'STRIPE.GOOGLEPAY', method: 'google_pay', image: 'google-pay.svg', imageVariant: 'googlePay'}] : []),
].filter(choice => !org || walletOptionEnabled(org, assoc, choice.value));

export function checkoutIdentity(config) {
    const {info, facturation, ...financial} = config;
    const sorted = value => Array.isArray(value) ? value.map(sorted) : value && typeof value === 'object'
        ? Object.fromEntries(Object.keys(value).sort().filter(key => value[key] !== undefined).map(key => [key, sorted(value[key])])) : value;
    return JSON.stringify(sorted(financial));
}

export function walletIdentityMissing(values = {}) {
    return [
        ...(typeof values.homme === 'boolean' ? [] : ['homme']),
        ...['prenom', 'nom'].filter(key => typeof values[key] !== 'string' || !values[key].trim()),
        ...(values.perso === false ? ['raison', 'siren'].filter(key => typeof values[key] !== 'string' || !values[key].trim()) : []),
    ];
}

export function focusWalletField(form, name) {
    form.scrollToField(name, {block: 'center'});
    const field = form.getFieldInstance(name);
    const input = field?.querySelector?.('input:not([disabled]),textarea:not([disabled]),select:not([disabled])') ||
        field?.nativeElement?.querySelector?.('input:not([disabled]),textarea:not([disabled]),select:not([disabled])');
    (input || field)?.focus?.();
}

// Preserve explicitly entered / authenticated identity. Stripe's full name is
// not guessed into first and last names, and a wallet never supplies a company
// identifier or the registration's custom answers.
export function walletPrefill(values = {}, details = {}) {
    const address = details.address || {};
    const candidates = {email: details.email, tel: details.phone, adresse: [address.line1, address.line2].filter(Boolean).join(', '),
        postal: address.postal_code, ville: address.city, etat: address.state,
        pays: COUNTRY.find(item => item.abbreviation === address.country)?.country};
    return Object.fromEntries(Object.entries(candidates).filter(([key, value]) =>
        value && (values[key] === undefined || values[key] === null || values[key] === '')));
}

let sdkPromise;
export function loadStripeWalletSdk() {
    if (window.Stripe) return Promise.resolve(window.Stripe);
    if (!sdkPromise) sdkPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/';
        script.async = true;
        script.onload = () => window.Stripe ? resolve(window.Stripe) : reject(new Error('STRIPE_UNAVAILABLE'));
        script.onerror = () => {script.remove(); sdkPromise = null; reject(new Error('STRIPE_UNAVAILABLE'));};
        document.head.appendChild(script);
    });
    return sdkPromise;
}

export function checkoutToken() {
    if (window.crypto.randomUUID) return window.crypto.randomUUID();
    return Array.from(window.crypto.getRandomValues(new Uint8Array(24)), value => value.toString(16).padStart(2, '0')).join('');
}
